import { createReactiveSetup } from "fluidstate-preact";
import { createLocationData, URL } from "./location/location-data";
import { createLocationActions } from "./location/location-actions";
import { createLocationReactions } from "./location/location-reactions";
import {
	createPageData,
	createPageActions,
	createPageReactions,
} from "./page/page";
import { createReactive } from "fluidstate";

export const {
	withReactiveState: withAppState,
	ReactiveProvider: AppStateProvider,
} = createReactiveSetup(({ url }: { url?: URL }) => {
	const locationData = createReactive(createLocationData(url));
	const locationActions = createReactive(createLocationActions(locationData));
	const locationReactions = createLocationReactions(locationActions);

	const pageData = createReactive(createPageData(locationData));
	const pageActions = createReactive(createPageActions(locationActions));
	const pageReactions = createPageReactions(pageData);

	return {
		data: { locationData, pageData },
		actions: { locationActions, pageActions },
		reactions: [...locationReactions, ...pageReactions],
	};
});
